var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header-app',{attrs:{"infoUser":_vm.user}}),_c('nav-row'),_c('tab-day')],1)}
var staticRenderFns = []

export { render, staticRenderFns }